import { render, staticRenderFns } from "./navigation_bar.vue?vue&type=template&id=3fba54ca"
import script from "./navigation_bar.vue?vue&type=script&lang=js"
export * from "./navigation_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports